import { AuthScreen, Card } from '@dss/design-system'
import { Link } from '../../lib/router'
import { useDistributorBrand } from '../../lib/distributor-brand'
import { KeycloakLoginButton } from '../login/KeycloakLoginButton'

/** Восстановлением управляет Keycloak; портал не имитирует отправку писем. */
export function ForgotStep1() {
  const { current: brand } = useDistributorBrand()
  return <AuthScreen brand={brand ?? undefined}>
    <Card padding="lg">
      <h1>Восстановление доступа</h1>
      <p>Пароль меняется в службе входа Keycloak, а не на этой странице.
        Мы не отправляем письмо и не подтверждаем смену пароля здесь.</p>
      <ol>
        <li>Откройте страницу входа кнопкой ниже.</li>
        <li>Если на ней есть ссылка «Забыли пароль?», следуйте инструкциям Keycloak.</li>
        <li>Если ссылки нет или письмо не приходит, обратитесь к сотруднику,
          который предоставил вам доступ. Попросите его помочь с восстановлением учётной записи.</li>
      </ol>
      <p>Не передавайте никому свой пароль и не отправляйте его в сообщениях.</p>
      <KeycloakLoginButton />
      <p><Link to="/login">Назад ко входу в портал</Link></p>
    </Card>
  </AuthScreen>
}
